import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DashboardLayout from "../layout/Dashboard";
import { FormattedMessage } from "react-intl";
import { GroupDetails } from "components/pages/admin/users/GroupDetails";
import { getGroupDetails as getGroupDetailsApi } from "../../api/admin/groups";
import { Messages } from "../../components/layout/Messages/Messages";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import {
  NOTIFICATION_ADMIN_GROUP_ACTIONS,
  NOTIFICATION_VIEW_ADMIN_GROUP
} from '../../config/notifications';
import { DeleteGroup } from "components/pages/admin/users/tabs/groupsTable/actionButtons/DeleteGroup";
import { ROUTE_ADMIN_MANAGE } from "../../config/routes";
import { history } from "../../store/configureStore";
import { getAdminUsers } from "../../api/admin/users";
import { updateGroupWithUsers as updateGroupWithUsersApi } from "../../api/admin/groups";
import { getAdminAcls } from "../../api/admin/groups";
import { updateGroupWithAcls } from "../../api/admin/groups";
import { ACL } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { store } from '../../store/store';
import { hideNotification } from '../../store/actions/notification';
import { NOTIFICATION_ERROR } from '../../store/actions/types';
import './ViewAdminGroup.scss';

function ViewAdminGroupComponent(props) {
  const { groupId } = props.match.params;
  const [ group, setGroup ] = useState( {} );
  const [ users, setUsers ] = useState( [] );
  const [ usersNotInGroup, setUsersNotInGroup ] = useState( null );
  const [ usersInGroup, setUsersInGroup ] = useState( null );
  const [ permissions, setPermissions ] = useState( [] );
  const [ permissionsInGroup, setPermissionsInGroup ] = useState( null );
  const [ permissionsNotInGroup, setPermissionsNotInGroup ] = useState( null );
  const [ loadedUsers, setLoadedUsers ] = useState( false );
  const [ loadedAcls, setLoadedAcls ] = useState( false );

  useEffect( () => {
    getGroupDetails(groupId);

    return () => {
      if (store.getState().notification.type === NOTIFICATION_ERROR) {
        store.dispatch(hideNotification());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  useEffect( () => {
    if (! users.length) {
      return;
    }
    // Create users in group and not in group
    setUsersInGroup( group.users );

    let cloneUsersNotInGroup = [];
    let isUserInGroup = false;

    users.forEach( u => {
      isUserInGroup = false;
      group.users.forEach( item => {
        if (item.id === u.id) {
          isUserInGroup = true;
        }
      } );

      if (! isUserInGroup) {
        cloneUsersNotInGroup.push( u );
      }
    } );

    setUsersNotInGroup( cloneUsersNotInGroup );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ loadedUsers ] );

  useEffect( () => {
    if (! permissions.length) {
      return;
    }

    // Create permissions in group and permissions not in group
    let permissionsInGroup = [];
    let permissionsNotInGroup = [];
    let isPermissionGroup = false;

    permissions.forEach( p => {
      isPermissionGroup = false;
      group.acls.forEach( item => {
        if (item.id === p.id) {
          isPermissionGroup = true;
        }
      } );

      if (! isPermissionGroup) {
        permissionsNotInGroup.push( p );
      } else {
        permissionsInGroup.push( p );
      }
    } );

    setPermissionsNotInGroup( permissionsNotInGroup );
    setPermissionsInGroup( permissionsInGroup );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ loadedAcls ] );

  /**
   * Get group details
   * @param {string} [groupId]
   */
  const getGroupDetails = (groupId) => {
    if (! ACL.ADMIN.GROUPS.VIEW.hasAccess()) {
      return;
    }

    getGroupDetailsApi( {
      groupId: groupId,
      notificationId: NOTIFICATION_VIEW_ADMIN_GROUP
    } ).then( (response) => {
      if (response && response.data && response.data.id) {
        setGroup( response.data );
        // Call for get group details
        if (ACL.ADMIN.USERS.LIST.hasAccess()) {
          getAdminUsers( {
            disablePagination: true,
          } ).then( (response) => {
            setUsers( response.data );
            setLoadedUsers( true );
          } );
        }

        if (! ACL.ADMIN.GROUPS.LIST_ACLS.hasAccess()) {
          return;
        }

        getAdminAcls( {} )
          .then( (response) => {
            setPermissions( response.data );
            setLoadedAcls( true );
          } );
      }
    } );
  };

  /**
   * Update user in state after a success update on server
   * @object value
   */
  const updateGroup = (value) => {
    setGroup( value );
  }

  /**
   * Add or remove user in group
   * @param {array} users
   * @param {object} user
   * @param {string} method
   */
  const updateGroupWithUser = (users, user, method) => {
    let usersIds = users.map( (element) => element.id );

    updateGroupWithUsersApi( {
      data: {
        groups: [
          {
            id: group.id,
            users: usersIds
          }
        ]
      },
      notificationId: NOTIFICATION_ADMIN_GROUP_ACTIONS
    } ).then( response => {
      if (response && response.data) {
        updateUsersAfterGroupUpdate( user, method );
      }
    } );
  }

  const updateUsersAfterGroupUpdate = (user, method) => {
    let cloneUsersInGroup = [ ...usersInGroup ];
    let cloneUsersNotInGroup = [ ...usersNotInGroup ];
    let i = -1;

    if (method === 'add') {
      cloneUsersInGroup.push( user );
      // remove this user from usersNotInGroup
      cloneUsersNotInGroup.forEach( (item, index) => {
        if (item.id === user.id) {
          i = index;
          return;
        }
      } );
      if (i !== -1) {
        cloneUsersNotInGroup.splice( i, 1 );
      }
    } else {
      cloneUsersNotInGroup.push( user );
      // remove this user from usersNotInGroup
      cloneUsersInGroup.forEach( (item, index) => {
        if (item.id === user.id) {
          i = index;
          return;
        }
      } );

      if (i !== -1) {
        cloneUsersInGroup.splice( i, 1 );
      }
    }

    setUsersInGroup( cloneUsersInGroup );
    setUsersNotInGroup( cloneUsersNotInGroup );
  }

  const submitPermissions = () => {
    let permissionsIds = permissionsInGroup.map( (element) => element.id );

    const payload = {
      data: {
        id: group.id,
        acl: permissionsIds,
      },
      notificationId: NOTIFICATION_ADMIN_GROUP_ACTIONS
    };

    updateGroupWithAcls( payload ).then( () => {
    } );
  };

  const updatePermissions = (permissionsInGroup, permissionsNotInGroup) => {
    setPermissionsInGroup( permissionsInGroup );
    setPermissionsNotInGroup( permissionsNotInGroup );
  };

  const title = group && group.id ? group.name : <FormattedMessage id="pages.admin.view_group.title"/>;

  return (
    <DashboardLayout location={props.location} className="dashboard" workspace={true}>
      <PageWorkspace className="admin-group-detail-workspace">
        <PageSurface className="admin-group-detail-surface">
          <PageHeader
            actions={group && group.id && ACL.ADMIN.GROUPS.DELETE.hasAccess() ? <DeleteGroup
              group={group}
              index={1}
              actionCallback={() => history.push( ROUTE_ADMIN_MANAGE )}
            /> : null}
            className="admin-group-detail-header"
            title={title}
          >
            {group && group.id && <div className="admin-group-detail-context">
              <FormattedMessage id="pages.admin.view_group.title"/>
            </div>}
            <div className="admin-group-detail-notifications">
              <Messages/>
              <Messages notificationId={NOTIFICATION_VIEW_ADMIN_GROUP}/>
              <Messages notificationId={NOTIFICATION_ADMIN_GROUP_ACTIONS}/>
            </div>
          </PageHeader>
          {!ACL.ADMIN.GROUPS.VIEW.hasAccess() ? <NoRights/> : <GroupDetails
            location={props.location}
            group={group}
            updateGroup={updateGroup}
            usersInGroup={usersInGroup}
            usersNotInGroup={usersNotInGroup}
            updateGroupWithUser={updateGroupWithUser}
            permissionsInGroup={permissionsInGroup}
            permissionsNotInGroup={permissionsNotInGroup}
            updatePermissions={updatePermissions}
            submitPermissions={submitPermissions}
          />}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ( {} );

const ViewAdminGroup = connect( mapStateToProps, null )( ViewAdminGroupComponent );

export { ViewAdminGroup, ViewAdminGroupComponent };
